// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__SaySX","header":"MessagesList_header__ZiYZq","chat":"MessagesList_chat__2znnv"};